export default __webpack_public_path__ + "assets/gallery-3.png";